import axios from "@/index";
const marketingSX = {
  state: {
    marketingSXList: []
  },
  getters: {},
  actions: {
    getSXApplicationList: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setSXApplicationList",
                (state, { marketingSXList: response.data })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  mutations: {
    setSXApplicationList(state, action) {
      state.marketingSXList = action.marketingSXList;
    }
  }
};
export default marketingSX;
